var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn",attrs:{"disabled":_vm.loading},on:{"click":_vm.submit}},[(_vm.loading)?_c('i',{staticClass:"fa fa-spin fa-spinner"}):_vm._e(),_vm._v(" "),_vm._t("default",function(){return [_vm._v("in den Warenkorb")]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }